/**
 * @file navigation-language-links.js
 *
 * This script ensures all internal navigation links have the correct language prefix
 * based on Drupal's settings. It scans each navigation link and prepends the appropriate
 * language prefix if it's missing. External links and anchor links remain unchanged.
 */

(function ($, Drupal, once, drupalSettings) {
  'use strict';

  Drupal.behaviors.kodakNavigationLinks = {
    attach: function (context, settings) {
      once('navigation-menu', '.navigation-menu', context).forEach(function () {

        // Get the current language prefix and clean up any extra slashes
        let langPrefix = (drupalSettings.path.pathPrefix || '').replace(/^\/+/g, '').replace(/\/+$/g, '');

        // Define regex to match existing language prefixes (supports single and multi-part like 'zh-hans')
        let existingLangPattern = new RegExp('^/' + langPrefix.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));

        $('.navigation-menu .navbar-nav a').each(function () {

          // Get the link URL
          let url = $(this).attr('href');

          // Check if link exists and is not external or an anchor link
          if (url && !url.startsWith('http') && !url.startsWith('#')) {

            // Check if the link already has the language prefix
            let hasLangPrefix = existingLangPattern.test(url);

            // If the link doesn't already have a language prefix, prepend the correct one
            if (!hasLangPrefix) {
              let updatedHref = '/' + langPrefix + '/' + url.replace(/^\/+/g, '');
              $(this).attr('href', updatedHref);
            } else {
              // Ensure it does not double the prefix if already exists
              let correctedHref = url.replace(new RegExp('^/' + langPrefix + '/'), '/' + langPrefix + '/');
              $(this).attr('href', correctedHref);
            }
          }
        });
      });
    }
  };
})(jQuery, Drupal, once, drupalSettings);
